import { string } from 'prop-types';

const countryBasicInformationPropTypes = {
  name: string,
  countryCode: string,
};

export default countryBasicInformationPropTypes;
